import Config           from '../../common/model/Config';
import GlobalVar        from '../../common/model/GlobalVar';
import UmdOption        from '../../common/model/UmdOption';
import Provider         from '../../common/model/Provider';
import {ajax}           from '../../common/controller/ajaxCtrl';
import { webAccess }    from '../../common/controller/webAccessibilityCtrl';
import {mobileFn}       from '../../common/utils/oacx.mobile.fn'
import {process}        from '../service/data.processing.srv'
import {appendHistory}  from './demo';
import { device, isDevice_TB_WBK_Portrait } from '../../common/utils/deviceCheck';
import {viewEvent}      from './viewEventCtrl'
import {template}       from './templateCtrl'
import { mobile }       from './mobileCtrl';

function msg_view(res, fnEvent){
    var errMsg = "서비스가 원활하지 않습니다. 잠시 후에 다시 시도해주십시오.";
    if(typeof res  == "string" && res.replace(/\s/gi, "") != ""){
        const json = JSON.parse(res);
        if(json !== undefined){
            if(json.resultCode != 200 && json.resultCode != 0){
                errMsg = json.clientMessage !== undefined ? json.clientMessage : errMsg;
            }
        }
    }
    viewEvent.view_msg("안내","",errMsg, fnEvent);
    $(`${Config.appendElementTagId} #oacxEmbededContents`).show();
}

var rootId = "";
export const viewAsyn = {
    getTokenProviderListPopup: ()=>{
        rootId = Config.appendElementTagId;
        ajax.getToken().then((res)=>{
            appendHistory("tokenLog",res);
            ajax.getProviderList().then(sRes=>{
                if(sRes != null && sRes !== undefined & sRes != "" && sRes.length != 0){
                    const providerList = process.providerService(sRes);
                    template.providerInfo({list:providerList});
                    viewEvent.showStep1();
                    viewEvent.showBackScreen();
                    viewEvent.serviceSelect();
                    webAccess.activeAuthPopup();
                    UmdOption.callback.loaded();
                    
                    if(GlobalVar.loadedModule !== undefined){
                        const loadedModule = GlobalVar.loadedModule
                        loadedModule($("#oacxEmbededContents")[0]);
                    }
                }
            },res=>{
                msg_view(res,viewEvent.closePopup);
            });
        },res=>{
            msg_view(res,viewEvent.closePopup);
        })
    },
    //인증요청
    requestAuth: ()=>{
        //Callback URI 등록
        //프로바이더 및 브라우저 정보 정리
        //버전이 낮을 경우 토큰발급 중지
        if(!mobileFn.setKakaoCallbackUrl()){
            return false;
        }
        viewEvent.hideStepBtn();

        ajax.requestAuth().then(res => {
            mobileFn.moveLinkByProvider();
            $(`${rootId} .mAgreeBg`).removeClass("view");
            $(`${rootId} #authSuccess`).removeAttr("disabled");
            $(`${rootId} #authSuccess`).removeClass("disabled");
            mobile.show_agree_button();

            viewEvent.view_wait_provider();
            viewEvent.showStepBtn();
            appendHistory("auth1Log",res);
        }, res => {
            viewEvent.showStepBtn();
            msg_view(res, ()=>{
                if(device.isMobile()){
                    webAccess.targetFocus(`${rootId} #mAgreeCstBtn`);
                }else{
                    webAccess.targetFocus(`${rootId} #step1Request`);
                }
                UmdOption.callback.ajax.fail.authRequestAlertConfirm(res);
            });
        })
    },    
    //인증완료
    finishAuth: (callback)=>{
        viewEvent.hideStepBtn();
        ajax.finishAuth().then(res => {
            callback(res);
            
            viewEvent.closePopup();
            appendHistory("auth2Log",res);
        },res => {
            viewEvent.showStepBtn();
            msg_view(res, ()=>{
                webAccess.targetFocus(`${rootId} #step2Success`);
                UmdOption.callback.ajax.fail.authCompleteAlertConfirm(res);
            });
        })
    }
}